import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Panel, Btn, Field, Input } from "@/admin/ui";

export default function Account() {
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [regenCode, setRegenCode] = useState("");
  const [codes, setCodes] = useState([]);

  const changePw = async () => {
    try { await api.post("/api/auth/change-password", pw); toast.success("Password changed"); setPw({ current_password: "", new_password: "" }); }
    catch (e) { toast.error(apiError(e)); }
  };
  const regen = async () => {
    try { const { data } = await api.post("/api/auth/mfa/backup-codes/regenerate", { code: regenCode }); setCodes(data.backup_codes); setRegenCode(""); toast.success("New backup codes generated"); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div data-testid="admin-account">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">My Account</h1>
      <div className="grid gap-4 lg:grid-cols-2">
        <Panel title="Change password" testid="account-password">
          <div className="space-y-4">
            <Field label="Current password"><Input type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="acc-current-pw" /></Field>
            <Field label="New password"><Input type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="acc-new-pw" /></Field>
            <Btn onClick={changePw} data-testid="acc-change-pw">Update password</Btn>
          </div>
        </Panel>
        <Panel title="Recovery codes" testid="account-backup">
          <div className="space-y-4">
            <p className="text-sm text-ink-muted">Regenerating invalidates previous backup codes. Enter your current authenticator code to confirm.</p>
            <Field label="Authenticator code"><Input inputMode="numeric" value={regenCode} onChange={(e) => setRegenCode(e.target.value)} data-testid="acc-regen-code" /></Field>
            <Btn variant="teal" onClick={regen} data-testid="acc-regen">Generate new codes</Btn>
            {codes.length > 0 && (
              <div className="grid grid-cols-2 gap-2 rounded-lg bg-slate-100 p-4 font-mono text-sm">
                {codes.map((c) => <div key={c} className="text-center">{c}</div>)}
              </div>
            )}
          </div>
        </Panel>
      </div>
    </div>
  );
}
